const bridgeData = {};

const setBridgeData = (key: string, value: any) => {
  bridgeData[key] = value;
};

const getBridgeData = () => {
  return bridgeData;
};

const getBridgeDataByKey = (key: string) => {
  return bridgeData[key];
};

export { setBridgeData, getBridgeData, getBridgeDataByKey };
